import { render, staticRenderFns } from "./blueButton.vue?vue&type=template&id=f525f068&scoped=true"
import script from "./blueButton.vue?vue&type=script&lang=js"
export * from "./blueButton.vue?vue&type=script&lang=js"
import style0 from "./blueButton.vue?vue&type=style&index=0&id=f525f068&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f525f068",
  null
  
)

export default component.exports